import getters from './getters'
import { actions as actions } from './actions'
import { mutations } from './mutations'

const state = {
  token: {
    loading: true,
    data: null,
    value: localStorage.getItem('token'),
    isAuthenticated: localStorage.getItem('token'),
    error: false
  },
  user: {
    loading: true,
    data: null,
    error: false
  },
  login: {
    form: {
      error: null,
      loading: false
    },
    remember: false
  },
  register: {
    form: {
      error: null,
      loading: false
    },
  },
  verifyPhoneNumber: {
    loading: true,
    data: null,
    error: false
  },
  resetPassword: {
    loading: true,
    data: null,
    error: false
  },  
  isAuthenticated: false,
  redirectAfterAuth: null
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/auth/index.js
// module id = null
// module chunks = 